module.exports = __webpack_public_path__ + "9c610f34f49497748419aa61ed2ffa13.jpg";


//////////////////
// WEBPACK FOOTER
// ./design/photos/schalen/Ruoff_091114_0046_w.jpg
// module id = 374
// module chunks = 0